<template>
  <div style="margin-top: 4em">
    <mdb-container>
      <mdb-row>
        <mdb-col col="12">
          <div class="mx-auto mt-4 ">
            <h5 class="font-weight-bold pt-0 pl-1 pr-5 mb-4 ">中国广州公司（总部）：</h5>
            <address>地址： 广州市越秀区先烈中路69号东山广场18楼<a href="http://j.map.baidu.com/eUv4J" target="_blank"
                                                class="text-danger"></a></address>
            <address>邮编： 510095</address>
            <address>电话： 020-87321000</address>
            <address>传真： 020-87321120</address>
            <address>邮箱： info@gasheng.com</address>
          </div>
        </mdb-col>

      </mdb-row>
    </mdb-container>
  </div>
</template>

<script>
export default {
  name: 'Contact'
}
</script>

<style scoped>

</style>
